import { render, staticRenderFns } from "./balance-inconsistency-check-modal.vue?vue&type=template&id=20be5eb5"
import script from "./balance-inconsistency-check-modal.vue?vue&type=script&lang=js"
export * from "./balance-inconsistency-check-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports